
// import * as constants from "../constants/CONSTANT";
// import axios from "axios";

// export default class DataApi {
//   constructor(path) {
//     this.token = sessionStorage.getItem("token");
//     this.branchId = JSON.parse(sessionStorage?.getItem('selectedBranch'))?.id || null;
//     this.baseUrl = `${constants.API_BASE_URL}/api/${path}`;
//   }

//   getHeaders(contentType = false) {
//     const headers = {};

//     if (contentType) {
//       headers["Content-Type"] = "application/json";
//     }

//     if (this.token) {
//       headers.Authorization = this.token.startsWith("Bearer ")
//         ? this.token
//         : `Bearer ${this.token}`;
//     }
//     if(this.branchId)
//       headers["Branch-Id"] = this.branchId;

//     return headers;
//   }
//   fetchAll(queryString = "") {
//     const url = queryString
//       ? `${this.baseUrl}?${queryString}`
//       : this.baseUrl;
//     return axios.get(url, { headers: this.getHeaders() });
//   }

//   fetchById(id) {
//     const url = id ? `${this.baseUrl}/${id}` : this.baseUrl;
//     return axios.get(url, { headers: this.getHeaders() });
//   }

//   create(data) {
//     const isFormData = data instanceof FormData;
//     console.log("isformdata",isFormData)
//     return axios.post(this.baseUrl, data, {
//       headers: isFormData ? this.getHeaders() : this.getHeaders(true),
//     });
//   }

//   update(data,id ) {
//     console.log("data",data)
//     console.log("id",id)
//     return axios.put(`${this.baseUrl}/${id}`, data, {
//       headers: this.getHeaders(true),
//     });
//   } 

//   post(url, data) {
//     return axios.post(this.baseUrl + url, data, {
//       headers: this.getHeaders(true),
//     });
//   }

//   put(url, data) {
//     return axios.put(this.baseUrl + url, data, {
//       headers: this.getHeaders(true),
//     });
//   }

//   get(url, config = {}) {
//     return axios.get(this.baseUrl + url, {
//       headers: this.getHeaders(),
//       ...config,
//     });
//   }

//   delete(id) {
//     console.log("Deleting ID:", id);
//     return axios.delete(`${this.baseUrl}/${id}`, {
//       headers: this.getHeaders(),
//     });
//   }

//   deleteWithBody(url, data) {
//     return axios.delete(this.baseUrl + url, {
//       data,
//       headers: this.getHeaders(true),
//     });
//   }
//   async search(params = {}) {
//     const { display_fields, ...otherParams } = params;

//     const res = await axios.get(this.baseUrl, {
//       params: {
//         ...otherParams,
//         ...(display_fields && { display_fields }),
//       },
//       headers: this.getHeaders(),
//     });

//     return res.data;
//   }

//   updateFormData(formData, id) {
//     console.log( "Updating form data for ID:", id );
//     console.log("formData", formData);
//     return axios.put(`${this.baseUrl}/${id}`, formData, {
//       headers: {
//         ...this.getHeaders(),
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   }

//     upsert(data) {
//     return axios.post(this.baseUrl, data, {
//       headers: this.getHeaders(true),
//     });
//   }

//   fetchIssuedCountByBookId(bookId) {
//     if (!bookId) throw new Error("Book ID required");

//     return axios.get(
//       // `${this.baseUrl}/${bookId}/issued-count`,
//       `${this.baseUrl}/${bookId}/submit-count`,
//       { headers: this.getHeaders() }
//     );
//   }

//   fetchInventoryReport() {
//     return axios.get(`${this.baseUrl}/inventory-report`, { headers: this.getHeaders() });
//   }

//   fetchSubmitCountByBookId(bookId) {
//     if (!bookId) throw new Error("Book ID required");

//     return axios.get(
//       `${this.baseUrl}/${bookId}/submit-count`,
//       { headers: this.getHeaders() }
//     );
//   }


//   createLibraryCard(formData) {
//     const data = new FormData();

//     Object.keys(formData).forEach((key) => {
//       if (
//         key !== "image" &&
//         formData[key] !== null &&
//         formData[key] !== undefined
//       ) {
//         data.append(key, formData[key]);
//       }
//     });

//     if (formData.image instanceof File) {
//       data.append("image", formData.image);
//     }

//     return axios.post(this.baseUrl, data, {
//       headers: {
//         ...this.getHeaders(),
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   }

//   updateLibraryCard(formData, id) {
//     return axios.put(`${this.baseUrl}/${id}`, formData, {
//       headers: {
//         ...this.getHeaders(),
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   }

//   async requestAccess() {
//     try {
//       const response = await this.post('/request-access', {});
//       return response.data;
//     } catch (error) {
//       console.error("Request access error:", error);
//       return { success: false, errors: "Network error. Please try again." };
//     }
//   }
// }



import * as constants from "../constants/CONSTANT";
import axios from "axios";
import jwt_decode from "jwt-decode";

const SESSION_EXPIRED_MESSAGE = "Aapka 1 saal ka plan expire ho gaya hai. Plan upgrade karke dobara login karein.";

const logoutUser = (message = "") => {
  sessionStorage.clear();
  if (message) {
    sessionStorage.setItem("logout_message", message);
  }
  window.location.href = "/login";
};

const getStoredPermissions = () => {
  try {
    const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
    return Array.isArray(permissions) ? permissions : [];
  } catch (error) {
    return [];
  }
};

const hasSessionExpired = () => {
  const token = sessionStorage.getItem("token");
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload?.session_expiry) return false;

    return Date.now() >= new Date(payload.session_expiry).getTime();
  } catch (error) {
    return false;
  }
};

export default class DataApi {
  constructor(path) {
    let selectedBranch = JSON.parse(sessionStorage?.getItem('selectedBranch'));
    this.branchId = selectedBranch ? selectedBranch?.id ? selectedBranch.id : selectedBranch : null;
    this.baseUrl = `${constants.API_BASE_URL}/api/${path}`;
  }

  getHeaders(token, contentType = false) {
    const headers = {};

    if (contentType) {
      headers["Content-Type"] = "application/json";
    }

    if (token) {
      headers.Authorization = token.startsWith("Bearer ")
        ? token
        : `Bearer ${token}`;
    }
    if (this.branchId)
      headers["Branch-Id"] = this.branchId;

    return headers;
  }

  async getValidAccessToken() {
    let accessToken = sessionStorage.getItem("token");
    const refreshToken = sessionStorage.getItem("r-t");

    if (!accessToken || !refreshToken) {
      logoutUser();
      throw new Error("No tokens available");
    }

    if (hasSessionExpired()) {
      logoutUser(SESSION_EXPIRED_MESSAGE);
      throw new Error("Session expired");
    }

    let decodedAccess;
    let decodedRefresh;

    try {
      decodedAccess = jwt_decode(accessToken);
    } catch (error) {
      logoutUser();
      throw new Error("Invalid access token");
    }

    try {
      decodedRefresh = jwt_decode(refreshToken);
    } catch (error) {
      logoutUser();
      throw new Error("Invalid refresh token");
    }

    if (Date.now() >= decodedRefresh.exp * 1000) {
      logoutUser();
      throw new Error("Refresh token expired");
    }

    if (Date.now() < decodedAccess.exp * 1000) {
      return accessToken;
    }

    const response = await fetch(`${constants.API_BASE_URL}/api/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refreshToken }),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      logoutUser(
        result?.errors ||
        result?.error ||
        (result?.errorCode === "SESSION_EXPIRED"
          ? SESSION_EXPIRED_MESSAGE
          : "")
      );
      throw new Error("Failed to refresh token");
    }

    sessionStorage.setItem("token", result.authToken);
    sessionStorage.setItem("r-t", result.refreshToken || refreshToken);
    sessionStorage.setItem("permissions", JSON.stringify(getStoredPermissions()));

    accessToken = result.authToken;

    try {
      const refreshedUser = jwt_decode(accessToken);
      this.branchId = refreshedUser.branch_id || this.branchId;
    } catch (error) {
      console.error("Failed to decode refreshed access token:", error);
    }

    return accessToken;
  }

  async request(method, url, data = undefined, options = {}) {
    const token = options.token || await this.getValidAccessToken();
    const baseHeaders = this.getHeaders(token, options.contentType);
    const headers = {
      ...baseHeaders,
      ...(options.headers || {}),
    };

    return axios({
      method,
      url,
      data,
      params: options.params,
      headers,
      ...options.config,
    });
  }

  async fetchAll(queryString = "") {
    const url = queryString
      ? `${this.baseUrl}?${queryString}`
      : this.baseUrl;
    return this.request("get", url);
  }

  async fetchById(id) {
    const url = id ? `${this.baseUrl}/${id}` : this.baseUrl;
    return this.request("get", url);
  }

  async create(data) {
    const isFormData = data instanceof FormData;
    console.log("isformdata", isFormData)
    return this.request("post", this.baseUrl, data, {
      contentType: !isFormData,
    });
  }

  async update(data, id) {
    console.log("data", data)
    console.log("id", id)
    return this.request("put", `${this.baseUrl}/${id}`, data, {
      contentType: true,
    });
  }

  async post(url, data) {
    return this.request("post", this.baseUrl + url, data, {
      contentType: true,
    });
  }

  async put(url, data) {
    return this.request("put", this.baseUrl + url, data, {
      contentType: true,
    });
  }

  async get(url, config = {}) {
    return this.request("get", this.baseUrl + url, undefined, {
      config,
    });
  }

  async delete(id) {
    console.log("Deleting ID:", id);
    return this.request("delete", `${this.baseUrl}/${id}`);
  }

  async deleteWithBody(url, data) {
    return this.request("delete", this.baseUrl + url, data, {
      contentType: true,
    });
  }
  async search(params = {}) {
    const { display_fields, ...otherParams } = params;
    const res = await this.request("get", this.baseUrl, undefined, {
      params: {
        ...otherParams,
        ...(display_fields && { display_fields }),
      },
    });

    return res.data;
  }

  async updateFormData(formData, id) {
    console.log("Updating form data for ID:", id);
    console.log("formData", formData);
    return this.request("put", `${this.baseUrl}/${id}`, formData, {
      headers: {
        ...this.getHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async upsert(data) {
    return this.request("post", this.baseUrl, data, {
      contentType: true,
    });
  }

  async fetchIssuedCountByBookId(bookId) {
    if (!bookId) throw new Error("Book ID required");

    return this.request(
      "get",
      `${this.baseUrl}/${bookId}/submit-count`,
      undefined
    );
  }

  async fetchInventoryReport() {
    return this.request("get", `${this.baseUrl}/inventory-report`);
  }

  async fetchSubmitCountByBookId(bookId) {
    if (!bookId) throw new Error("Book ID required");

    return this.request(
      "get",
      `${this.baseUrl}/${bookId}/submit-count`,
      undefined
    );
  }


  async createLibraryCard(formData) {
    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (
        key !== "image" &&
        formData[key] !== null &&
        formData[key] !== undefined
      ) {
        data.append(key, formData[key]);
      }
    });

    if (formData.image instanceof File) {
      data.append("image", formData.image);
    }

    return this.request("post", this.baseUrl, data, {
      headers: {
        ...this.getHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async updateLibraryCard(formData, id) {
    return this.request("put", `${this.baseUrl}/${id}`, formData, {
      headers: {
        ...this.getHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async requestAccess() {
    try {
      const response = await this.post('/request-access', {});
      return response.data;
    } catch (error) {
      console.error("Request access error:", error);
      return { success: false, errors: "Network error. Please try again." };
    }
  }
}

